import { createPageApp } from '@/lib/createPageApp'
import TeacherMaterialsPage from './TeacherMaterialsPage.vue'

createPageApp(TeacherMaterialsPage).mount()
